<template>
  <a-transfer
    :data-source="mockData"
    show-search
    :disabled="disabled"
    :list-style="{ width: '45%', height: '300px' }"
    :titles="['审批人', '已选择']"
    :target-keys="targetKeys"
    :render="item => `${item.title} - ${item.description}`"
    @change="handleChange"
    @selectChange="handleSelectChange"
  />
</template>
<script>
export default {
  data() {
    return {
      mockData: [],
      targetKeys: [],
      disabled: false,
    }
  },
  props: ['list'],
  watch: {
    list: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.list = newValue
        const mockData = []
        const targetKeys = []
        for (let i = 0; i < this.list.length; i++) {
          const data = {
            key: `${this.list[i].username}_${i}`,
            title: `${this.list[i].name}(${this.list[i].username})`,
            chosen: i > this.list.length - 2,
            description: i > this.list.length - 2 ? '归档审批人' : '担保审批人',
            disabled: i == this.list.length - 1,
          }
          if (data.chosen) {
            targetKeys.push(data.key)
          }
          mockData.push(data)
        }
        this.mockData = mockData
        this.targetKeys = targetKeys
      },
    },
  },

  methods: {
    handleChange(newtargetKeys) {
      this.targetKeys = newtargetKeys
    },
    handleSelectChange(sourceSelectedKeys, targetSelectedKeys) {
      this.targetKeys.splice(
        this.targetKeys.length - 1,
        0,
        ...sourceSelectedKeys,
      )

      if (targetSelectedKeys && targetSelectedKeys.length == 1) {
        const crtKey = targetSelectedKeys[0]
        const crtIndex = this.targetKeys.findIndex(key => key == crtKey)
        this.targetKeys.splice(crtIndex, 1)
      }
    },
    validate(showWarning = true) {
      const targetKeys = this.targetKeys
      if (targetKeys.length === 1) {
        showWarning &&
          this.$notification.warning({
            message: '提示',
            description: '请选择审批人',
          })
        return false
      }
      const approvePersons = targetKeys.map(key => {
        const info = key.split('_')
        return {
          username: info[0],
        }
      })
      return { approvePersons }
    },
  },
}
</script>
